<template>
  <div class="compressed-content">
    <h3>
      Based on your previous Cardiometabolic Risk Assessment, did your care <br />
      provider or health coach recommend any diet or lifestyle changes?
    </h3>
    <v-form-group class="card-selector page-buttons">
      <b-form-checkbox v-model="survey.feedback.hcpChangesCMR.noChanges" @change="deselectCheckboxes">
        No Changes
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.feedback.hcpChangesCMR.diet" :disabled="survey.feedback.hcpChangesCMR.noChanges === true">
        Diet
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.feedback.hcpChangesCMR.lifestyle" :disabled="survey.feedback.hcpChangesCMR.noChanges === true">
        Lifestyle
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.feedback.hcpChangesCMR.medical" :disabled="survey.feedback.hcpChangesCMR.noChanges === true">
        Medical
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],


    computed: {
      ...mapState(["survey"]),
    },


    methods: {
      deselectCheckboxes() {
        this.survey.feedback.hcpChangesCMR.diet = false;
        this.survey.feedback.hcpChangesCMR.lifestyle = false;
        this.survey.feedback.hcpChangesCMR.medical = false;
      },
    }
  };
</script>